import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Barcode from 'react-barcode';

const PrintBarcode = (props: any) => {
  return (
    <Box
      sx={{
        width: '100%',
        fontFamily: 'Arial, sans-serif',
        '@media print': {
          padding: '20mm',
        },
      }}
    >
      <Stack alignItems={'center'}>
        <Typography>バーコードを1枚発行しました</Typography>
        {props.data?.barcode && <Barcode value={props.data?.barcode} />}
        <Grid container spacing={3} sx={{ m: 0 }}>
          <Grid item xs={2}></Grid>
          <Grid item xs={4}>
            <Typography color={'#00000080'}>患者ID</Typography>
            <Typography>{props.data?.patient_number}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography color={'#00000080'}>製造日</Typography>
            <Typography>{props.data?.creation_date}</Typography>
          </Grid>
        </Grid>
        <Grid container spacing={3} sx={{ m: 0 }}>
          <Grid item xs={2}></Grid>
          <Grid item xs={4}>
            <Typography color={'#00000080'}>患者名</Typography>
            <Typography>{props.data?.patient_name}</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography color={'#00000080'}>保管期限</Typography>
            <Typography>{props.data?.expiry_date}</Typography>
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
};

export default PrintBarcode;
